export const az = {
  // Common
  loading: "Yüklənir...",
  back: "Geri",
  cancel: "Ləğv et",
  submit: "Göndər",
  create: "Yarat",
  delete: "Sil",
  edit: "Redaktə et",
  save: "Yadda saxla",
  confirm: "Təsdiqlə",
  logout: "Çıxış",
  login: "Daxil ol",
  
  // Landing Page
  appTitle: "Bina İdarəetmə Sistemi",
  appSubtitle: "Mənzil idarəetməsini asanlaşdırın, təmir haqqlarını izləyin, xərcləri izləyin və sakinləri məlumatlandırın.",
  signInGoogle: "Google ilə Daxil ol",
  signInManual: "İstifadəçi adı ilə Daxil ol",
  apartmentManagement: "Mənzil İdarəetməsi",
  apartmentManagementDesc: "Mənzilləri asanlıqla idarə edin və sakinləri təyin edin",
  feeTracking: "Haqqların İzlənməsi",
  feeTrackingDesc: "Təmir haqqlarını və ödəniş statusunu izləyin",
  announcements: "Elanlar",
  announcementsDesc: "Sakinləri yeniləmələrlə məlumatlandırın",
  
  // PandaProp Landing Page
  landingLogoAlt: "PandaProp Logosu",
  landingTitle: "PandaProp",
  landingSubtitle: "Tam Bina & Mənzil İdarəetməsi",
  landingDescription: "Mənzilləri, haqqları, xərcləri, investisiyaları, digər gəlirləri, elanları və maliyyə hesabatlarını tək bir çox kiracılı platformada idarə edin.",
  landingPrimaryCta: "Daxil ol",
  landingLoginHint: "Təyin olunmuş istifadəçi adı və şifrənizi istifadə edin",
  
  // Feature Cards
  featureApartments: "Mənzil & Sakin İdarəetməsi",
  featureApartmentsDesc: "Mərtəbələri, mənzilləri və sakin təyinatlarını asanlıqla idarə edin",
  featureDues: "Haqq İzləmə & Ödənişlər",
  featureDuesDesc: "Ödənmiş/ödənməmiş statusu ətraflı aylıq hesabatlarla izləyin",
  featureExpenses: "Xərc İdarəetməsi",
  featureExpensesDesc: "Bina xərclərini növə görə kateqoriyalara ayırın və izləyin",
  featureInvestments: "İnvestisiya İzləmə",
  featureInvestmentsDesc: "Bina layihələrini və kapital investisiyalarını izləyin",
  featureOtherIncome: "Digər Gəlirlər",
  featureOtherIncomeDesc: "Kirayə gəliri, haqqları və müxtəlif gəlirləri izləyin",
  featureAnnouncements: "Elanlar",
  featureAnnouncementsDesc: "Sakinləri bina genişliyində yeniləmələrlə məlumatlandırın",
  
  // Trust Bullets
  bulletMultiTenancy: "Bina əsaslı çox kiracılı struktur",
  bulletAdminResident: "Admin & Sakin portalları",
  bulletMonthlyReports: "Aylıq maliyyə xülasəsi & ətraflı hesabatlar",
  
  // Login Form
  username: "İstifadəçi adı",
  password: "Şifrə",
  usernameRequired: "İstifadəçi adı tələb olunur",
  passwordRequired: "Şifrə tələb olunur",
  invalidCredentials: "Yanlış istifadəçi adı və ya şifrə",
  
  // Dashboard
  adminDashboard: "Admin Paneli",
  residentPortal: "Sakin Portalı",
  totalCollected: "Yığılmış Məbləğ",
  totalUnpaid: "Ödənilməmiş Məbləğ",
  totalExpenses: "Ümumi Xərclər",
  viewOperatingLedger: "Əməliyyat Hesabı Dəftərini Görüntülə",
  close: "Bağla",
  
  // Operating Ledger
  operatingLedgerTitle: "Əməliyyat Hesabı Dəftəri",
  selectMonthYear: "Ay/İl Seçin",
  year: "İl",
  month: "Ay",
  apply: "Tətbiq Et",
  buildingName: "Bina Adı",
  ledgerRowNo: "Sıra",
  ledgerDate: "Tarix",
  ledgerDocNo: "Sənəd No",
  ledgerInvoiceNo: "Faktura No",
  ledgerInvoiceNoPlaceholder: "Faktura nömrəsini daxil edin",
  ledgerDescription: "Açıqlama",
  ledgerExpenses: "Xərclər",
  ledgerGoodsPurchases: "Mal Alışları",
  ledgerPaidVAT: "Ödənilmiş ƏDV",
  ledgerIncome: "Gəlirlər",
  ledgerGoodsSales: "Mal Satışları",
  ledgerCollectedVAT: "Yığılmış ƏDV",
  ledgerBalance: "Balans",
  ledgerTotal: "Cəmi",
  ledgerGrandTotal: "Ümumi Cəm",
  ledgerMaintenanceCollection: "Təmir Haqqı Yığımı",
  ledgerOtherIncome: "Digər Gəlir",
  ledgerNoRecords: "Bu dövr üçün qeyd yoxdur",
  ledgerUnit: "Mənzil",
  ledgerDevirBanka: "Bank Köçürməsi (Açılış Qalığı)",
  
  // Bank Statement Upload
  loadBankStatement: "Bank Hesabatı Yüklə",
  bankStatementResults: "Bank Hesabatı Təhlili",
  uploadExcelFile: "Excel faylı yükləyin (.xls və ya .xlsx)",
  selectFile: "Fayl Seç",
  analyzing: "Təhlil edilir...",
  aidatPayments: "Təmir Haqqı Ödəmələri",
  otherPaymentsSection: "Digər Ödəmələr (Qapıçı Kompensasiyası və s.)",
  expensesSection: "Xərclər",
  unidentifiedTransactions: "Tanınmayan Əməliyyatlar",
  totalAmount: "Ümumi Məbləğ",
  transactionCount: "Əməliyyat Sayı",
  apartmentsFound: "Tapılan Mənzillər",
  residentName: "Sakin Adı",
  periodLabel: "Dövr",
  noTransactionsFound: "Əməliyyat tapılmadı",
  parseError: "Fayl oxuna bilmədi",
  
  // Bank Statement - Unit Assignment & Posting
  assignUnit: "Mənzil Təyin Et",
  selectUnit: "Mənzil Seç",
  poolAccount: "Hovuz Hesabı",
  postToOperatingLedger: "İşletmə Dəftərinə Yaz",
  confirmPostTitle: "Qeydləri Təsdiqlə",
  confirmPostMessage: "Seçilmiş əməliyyatları işletmə hesabı dəftərinə yazmaq istədiyinizə əminsiniz?",
  posting: "Yazılır...",
  postingComplete: "Qeyd Tamamlandı",
  postingFailed: "Qeyd Uğursuz",
  bankStatementPosted: "Bank hesabatı uğurla yazıldı",
  transactionsProcessed: "İşlənmiş Əməliyyatlar",
  assignedToUnits: "Mənzillərə Təyin Edilən",
  assignedToPool: "Hovuza Təyin Edilən",
  expensesPosted: "Xərc Qeydləri",
  failedTransactions: "Uğursuz Əməliyyatlar",
  
  // Bank Statements Page
  bankStatementsTitle: "Bank Çıxarışları",
  bankStatementsNav: "Bank Çıxarışları",
  uploadedStatements: "Yüklənən Çıxarışlar",
  noStatementsYet: "Hələ bank çıxarışı yüklənməyib",
  uploadNewStatement: "Yeni Çıxarış Yüklə",
  statementFilename: "Fayl Adı",
  statementUploadDate: "Yükləmə Tarixi",
  statementPostDate: "Qeyd Tarixi",
  statementStatus: "Status",
  statementUploaded: "Yükləndi",
  statementPosted: "Qeyd edildi",
  viewDetails: "Təfərrüatlar",
  revertStatement: "Geri Al",
  deleteStatement: "Sil",
  revertConfirmTitle: "Bank Çıxarışını Geri Al",
  revertConfirmMessage: "Bu bank çıxarışını geri almaq istədiyinizə əminsiniz? Bu, bu çıxarışdan yaradılmış BÜTÜN qeydləri siləcək (xərclər, ödəmələr, hovuz qeydləri). Bu əməliyyat geri alına bilməz.",
  revertInProgress: "Geri alınır...",
  revertSuccess: "Bank çıxarışı uğurla geri alındı",
  revertFailed: "Geri alma uğursuz oldu",
  deleteConfirmTitle: "Bank Çıxarışını Sil",
  deleteConfirmMessage: "Bu bank çıxarışını silmək istədiyinizə əminsiniz? Yenidən istifadə etmək üçün faylı yenidən yükləməlisiniz.",
  deleteSuccess: "Bank çıxarışı silindi",
  expensesRemoved: "Silinən Xərclər",
  paymentsRemoved: "Silinən Ödəmələr",
  poolEntriesRemoved: "Silinən Hovuz Qeydləri",
  feesRecalculated: "Yenidən Hesablanan Haqlar",
  
  // Maintenance Payment Edit
  editMaintenancePayment: "Kommunal Ödəməni Düzəlt",
  currentUnit: "Cari Mənzil",
  period: "Dövr",
  assignToUnit: "Mənzilə Təyin Et",
  updateSuccess: "Uğurla yeniləndi",
  paymentReassigned: "Ödəmə yenidən təyin edildi",
  sameUnitSelected: "Eyni mənzil seçildi - dəyişiklik lazım deyil",
  
  // Pool Income
  poolIncome: "Hovuz Hesabı Gəliri",
  poolIncomeDetails: "Hovuz Gəliri Detalları",
  poolIncomeNote: "Hovuz gəlir qeydləri Bank Çıxarışları vasitəsilə idarə olunur. Dəyişdirmək üçün bank çıxarışını geri alıb yenidən idxal edin.",
  assignPoolToUnit: "Hovuz Gəlirini Mənzilə Təyin Et",
  poolAssignmentNote: "Bu, ödəməni seçilmiş mənzilin ən köhnə ödənilməmiş kommunal borclarına avtomatik tətbiq edəcək.",
  assignAndApply: "Təyin Et və Tətbiq Et",
  feesUpdated: "haqq yeniləndi",
  processing: "İşlənir...",
  otherPayment: "Digər Ödəmə",
  
  // Document Status (Sənəd Statusu)
  documentStatusActive: "Aktiv",
  documentStatusVoid: "Ləğv edilib",
  documentStatusReversal: "Əks Qeyd",
  voidReason: "Ləğv Səbəbi",
  reversalOf: "Əksi",
  reversedBy: "Ləğv edən",
  voidConfirmTitle: "Qeydi Ləğv Et",
  voidConfirmMessage: "Bu qeydi ləğv etmək istədiyinizə əminsiniz? Bu əməliyyat geri alına bilməz və əks qeyd yaradılacaq.",
  voidReasonPlaceholder: "Ləğv səbəbini daxil edin...",
  voidSuccess: "Qeyd uğurla ləğv edildi",
  
  // Edit Expense/Income
  editExpense: "Xərci Düzəlt",
  expenseUpdated: "Xərc uğurla yeniləndi",
  documentNoImmutable: "dəyişdirilə bilməz",
  
  // Past month expense warning
  pastMonthExpenseTitle: "Keçmiş Ay Xərci",
  pastMonthExpenseMessage: "Seçdiyiniz tarix əvvəlki aya aiddir. Bu xərc seçilmiş ayda deyil, daxil etdiyiniz tarixi ayda dəftərdə görünəcək. Davam etmək istəyirsiniz?",
  pastMonthExpenseCancel: "Ləğv et",
  pastMonthExpenseContinue: "Davam et",
  
  apartments: "Mənzillər",
  outstandingBalance: "Ödənilməmiş Balans",
  totalPaid: "Ümumi Ödənilmiş",
  
  // Navigation
  maintenanceFees: "Təmir Haqqları",
  expenses: "Xərclər",
  expenseReports: "Xərc Hesabatları",
  manageApartments: "Mənzilləri və sakinləri idarə edin",
  trackPayments: "Ödənişləri izləyin və idarə edin",
  recordExpenses: "Bina xərclərini qeyd edin",
  postUpdates: "Sakinlər üçün yeniləmələr dərc edin",
  viewUpdates: "Bina yeniləmələrini görün",
  seeExpenses: "Haqqların necə xərcləndiyini görün",
  
  // Sample Data
  generateSampleData: "Nümunə Məlumat Yarat",
  generateSampleDataDesc: "Demo üçün test məlumatı yarat",
  clearSampleData: "Nümunə Məlumatı Təmizlə",
  clearSampleDataDesc: "Bütün test məlumatını sil",
  sampleDataGenerated: "Nümunə məlumat yaradıldı",
  sampleDataCleared: "Nümunə məlumat təmizləndi",
  
  // Apartments
  newApartment: "+ Yeni Mənzil",
  unitNumber: "Mənzil Nömrəsi",
  floor: "Mərtəbə",
  resident: "Sakin",
  residents: "Sakinlər",
  assignResident: "Sakin təyin edin...",
  ownerLabel: "Sahib",
  tenantLabel: "Kirayəçi",
  selectOwner: "Sahib seçin...",
  selectTenantOptional: "Kirayəçi seçin (istəyə bağlı)...",
  ownerOccupied: "Sahib yaşayır",
  tenantOccupied: "Kirayədə",
  ownerTenantHint: "Aidat kirayəçiyə, digər ödənişlər sahibə təyin olunur.",
  occupancyStatus: "Doluluq Statusu",
  ownerRequired: "Sahib seçilməlidir.",
  tenantRequired: "Kirayədə olan mənzil üçün kirayəçi seçilməlidir.",
  samePersonError: "Sahib və kirayəçi eyni şəxs ola bilməz. Əgər sahib mənzildə yaşayırsa, kirayəçi sahəsini boş buraxın və 'Sahib yaşayır' seçin.",
  assignmentSaved: "Təyinat yadda saxlanıldı",
  tenantDebtReadOnly: "Kirayəçinin borcu (yalnız oxunur)",
  tenantDuesReadOnly: "Kirayəçinin aidat borcu (yalnız oxunur)",
  selectUnit: "Mənzil seçin",
  totalAllUnits: "Ümumi borc (bütün mənzillər)",
  yourDebtLabel: "Sizin borcunuz",
  residentAssigned: "Sakin təyin edildi",
  apartmentCreated: "Mənzil yaradıldı",
  apartmentDeleted: "Mənzil silindi",
  deleteApartment: "Bu mənzili silmək istədiyinizdən əminsiniz?",
  noResident: "Sakin yoxdur",
  assigned: "Təyin edilib",
  
  // Maintenance Fees
  newFee: "+ Yeni Haqq",
  amount: "Məbləğ",
  month: "Ay",
  year: "İl",
  status: "Status",
  actions: "Əməliyyatlar",
  period: "Dövr",
  paid: "ödənilib",
  unpaid: "ödənilməyib",
  partiallyPaid: "qismən ödənilib",
  markPaid: "Ödənilib kimi işarələ",
  markUnpaid: "Ödənilməmiş kimi qeyd et",
  markedAsUnpaid: "Ödənilməmiş kimi qeyd edildi",
  markedAsPaid: "Ödənilib kimi işarələndi",
  
  // Partial Payment System
  takePayment: "Ödəniş Al",
  payInFull: "Tam Ödə",
  partialPayment: "Qismən Ödəniş",
  paidAmount: "Ödənilən Məbləğ",
  remainingAmount: "Qalan Məbləğ",
  dueAmount: "Borc Məbləği",
  aidatAmount: "Aidat",
  otherPaymentAmount: "Digər Ödəniş",
  paymentAmount: "Ödəniş Məbləği",
  paymentMethod: "Ödəniş Metodu",
  paymentNote: "Ödəniş Qeydi",
  paymentRecorded: "Ödəniş qeyd edildi",
  cannotMarkUnpaidWithPayments: "Aktiv ödəniş qeydləri olduqda ödənilməmiş kimi qeyd edilə bilməz",
  partialPaymentLabel: "Qismən",
  paymentHistory: "Ödəniş Tarixçəsi",
  noPayments: "Hələ ödəniş yoxdur",
  
  // Simplified Payment Actions
  markAsPaid: "Ödənilib İşarələ",
  undoPayment: "Geri Al",
  undoPaymentConfirm: "Bu dövr üçün bütün ödənişləri geri almaq istədiyinizdən əminsiniz?",
  paymentUndone: "Ödəniş(lər) geri alındı",
  confirmPayment: "Ödənişi Təsdiqlə",
  paymentExceedsRemaining: "Ödəniş məbləği qalan borcdan çox ola bilməz",
  paymentDateYearWarning: "Ödəniş tarixi seçilmiş il daxilində olmalıdır",
  noApartments: "Mənzil tapılmadı. Əvvəlcə mənzil əlavə edin.",
  
  // Cumulative Balance System
  devirBakiyesi: "Açılış Qalığı",
  cumulativeRemaining: "Qalan (Kümülatif)",
  openingBalance: "Açılış Qalığı",
  cumulativeBalance: "Kümülatif Qalıq",
  
  // Initial Carryover System (one-time setup)
  initializeCarryover: "Açılış Qalığını Başlat",
  initialCarryoverAmount: "İlkin Köçürmə Məbləği",
  effectiveYear: "Qüvvəyə Minmə İli",
  initializeCarryoverHelp: "Bu mənzil üçün ilkin köçürmə qalığını bir dəfə təyin edin. Bu məbləğ, izləmənin başladığı il üçün başlanğıc qalığı kimi istifadə ediləcək. Sonrakı illərin köçürmə qalığı avtomatik olaraq əvvəlki ilin bağlanış qalığından hesablanacaq.",
  carryoverInitialized: "Açılış qalığı uğurla təyin edildi",
  carryoverAlreadySet: "Bu mənzil üçün ilkin köçürmə artıq təyin edilib. Dəyişdirilə bilməz.",
  carryoverNotInitialized: "Açılış qalığı hələ təyin edilməyib",
  carryoverSourceInitial: "İlkin məbləğ",
  carryoverSourcePreviousYear: "Əvvəlki il bağlanış qalığı",
  positiveIsDebt: "Müsbət = Borc, Mənfi = Kredit",
  immutableWarning: "Bu əməliyyat geri qaytarıla bilməz. Dəyişikliklərə icazə verilmir.",
  
  // Summary Footer
  totalDebt: "Ümumi Borc",
  totalCredit: "Ümumi Kredit",
  balance: "Balans",
  balanceZero: "Balans Sıfır",
  cumulativeAsOfToday: "Seçilmiş il və bugünə qədər kümülatif",
  monthNotStarted: "Bu ay hələ başlamayıb",
  cannotCreateFutureFees: "Gələcək aylar üçün haqq yaratmaq olmaz",
  futureMonthsNotCreated: "gələcək aylar üçün haqq yaradılmadı",
  
  // Advance Payments
  advancePayment: "Avans Ödəniş",
  advancePaymentInfo: "Bu ödəniş seçilmiş ay üçün avans olaraq işlənəcək.",
  advancePaymentAllocated: "Avans ödəniş qeydə alındı",
  advancePaymentDeleted: "Avans ödəniş silindi",
  allocatePayment: "Ödənişi Təyin Et",
  
  // Other Payments
  otherPayments: "Digər Ödənişlər",
  addOtherPayment: "+ Digər Ödəniş",
  otherPaymentSchedule: "Digər Ödəniş Planı",
  startMonth: "Başlanğıc Ayı",
  durationMonths: "Neçə Ay",
  amountPerMonth: "Aylıq Məbləğ",
  paymentDescription: "Təsvir",
  paymentDescriptionPlaceholder: "Ödəniş təsvirini daxil edin (məs: Təmir xərcləri, Lift baxımı)",
  otherPaymentCreated: "Digər ödəniş planı yaradıldı",
  otherPaymentDeleted: "Digər ödəniş planı silindi",
  otherPaymentCollection: "Digər Ödəniş Tahsilatı",
  selectMonth: "Ay seçin...",
  
  feeCreated: "Haqq yaradıldı",
  feeDeleted: "Haqq silindi",
  deleteFee: "Bu haqqı silmək istədiyinizdən əminsiniz?",
  apartment: "Mənzil",
  selectApartment: "Mənzil seçin...",
  generateYearlyFees: "İllik Ödənişləri Yarat",
  yearlyFeesGenerated: "İllik ödənişlər uğurla yaradıldı",
  allFeesAlreadyExist: "Bu il üçün bütün ödənişlər artıq mövcuddur",
  created: "yaradıldı",
  skipped: "atlandı",
  monthlyAmount: "Aylıq Məbləğ",
  all: "Hamısı",
  generate: "Yarat",
  
  // Expenses
  newExpense: "+ Yeni Xərc",
  addExpense: "+ Xərc əlavə et",
  category: "Kateqoriya",
  subcategory: "Alt Kateqoriya",
  date: "Tarix",
  description: "Təsvir",
  expenseCreated: "Xərc yaradıldı",
  expenseDeleted: "Xərc silindi",
  deleteExpense: "Bu xərci silmək istədiyinizdən əminsiniz?",
  expenseDetails: "Xərc Təfərrüatları",
  expenseReport: "Xərc Hesabatı",
  grandTotalExpense: "Ümumi Cəm",
  noExpensesYet: "Hələ qeydə alınmış xərc yoxdur",
  addFirstExpense: "ilk xərcinizi əlavə etmək üçün klikləyin",
  expenseDistribution: "Xərc Paylanması",
  noExpenseData: "Göstəriləcək xərc məlumatı yoxdur",
  itemCount: "ədəd",
  items: "qələm",
  collapseAll: "Hamısını Daralt",
  expandAll: "Hamısını Genişlət",
  categoryLabel: "Kateqoriya",
  categoryPlaceholder: "Kateqoriya seçin",
  subcategoryLabel: "Alt Kateqoriya",
  subcategoryPlaceholder: "Alt kateqoriya seçin",
  categoryRequired: "Kateqoriya seçimi məcburidir",
  subcategoryRequired: "Alt kateqoriya seçimi məcburidir",
  
  // Xərc Kateqoriyaları
  expenseCategories: {
    commonArea: "Ümumi Sahə & Əməliyyatlar",
    maintenance: "Təmir & Bərpa",
    management: "İdarəetmə & Əməliyyat",
    taxOfficial: "Vergi & Rəsmi",
    insurance: "Sığorta & Təhlükəsizlik",
    other: "Digər"
  },
  
  // Xərc Alt Kateqoriyaları
  expenseSubcategories: {
    commonArea: {
      cleaning: "Təmizlik",
      security: "Təhlükəsizlik",
      janitor: "Qapıçı / İşçi Maaşı",
      reception: "Resepşn / Məsləhətçi",
      gardening: "Bağ Baxımı / Landşaft",
      elevatorMaintenance: "Lift Baxımı & Servisi",
      generatorMaintenance: "Generator Baxımı",
      fireSystemsMaintenance: "Yanğın Sistemləri Baxımı",
      poolMaintenance: "Hovuz Baxımı & Kimyəvi Maddələr",
      commonElectricity: "Ümumi Sahə Elektrik",
      commonWater: "Ümumi Sahə Su",
      naturalGas: "Təbii Qaz (Ümumi Sahə)"
    },
    maintenance: {
      electricalRepair: "Elektrik Təmiri",
      plumbingRepair: "Su / Santexnika Təmiri",
      elevatorBreakdown: "Lift Nasazlığı",
      roofRepair: "Dam Təmiri",
      paintingRenovation: "Rəngləmə & Təmir",
      fixtureRepair: "Avadanlıq Təmiri",
      emergencyRepairs: "Təcili Təmirlər"
    },
    management: {
      managerFee: "Menecer Haqqı",
      accountingAdvisor: "Mühasibat / Maliyyə Məsləhətçisi",
      buildingManagementService: "Bina İdarəetmə Xidməti",
      legal: "Hüquqi / Vəkil",
      consultancy: "Məsləhət",
      stationeryOffice: "Dəftərxana & Ofis",
      softwareSystem: "Proqram / Sistem"
    },
    taxOfficial: {
      taxes: "Vergilər",
      municipalityFees: "Bələdiyyə Haqları",
      licenseProcedures: "Lisenziya & Rəsmi Prosedurlar",
      penaltiesFees: "Cərimə / Gecikdirmə Haqları"
    },
    insurance: {
      buildingInsurance: "Bina Sığortası",
      assetInsurance: "Aktivlər Sığortası",
      occupationalHealth: "Peşə Sağlamlığı & Təhlükəsizlik",
      fireExtinguisher: "Yanğınsöndürən / Avadanlıq"
    },
    other: {
      pestControl: "Zərərvericilərlə Mübarizə",
      wasteManagement: "Zibil / Tullantı İdarəetməsi",
      snowRemoval: "Qar Təmizləmə / Mövsümi",
      generalExpense: "Ümumi Xərc",
      other: "Digər"
    }
  },
  
  // Announcements
  newAnnouncement: "+ Yeni Elan",
  title: "Başlıq",
  content: "Məzmun",
  latestAnnouncements: "Son Elanlar",
  announcementCreated: "Elan yaradıldı",
  announcementDeleted: "Elan silindi",
  deleteAnnouncement: "Bu elanı silmək istədiyinizdən əminsiniz?",
  
  // Settings
  settings: "Parametrlər",
  language: "Dil",
  currency: "Valyuta",
  settingsUpdated: "Parametrlər yeniləndi",
  personalLanguageSetting: "Şəxsi dil seçimi",
  systemCurrencySuperAdmin: "Sistem üzrə valyuta parametri",
  systemCurrencyReadOnly: "Sistem üzrə valyuta (Yalnız SuperAdmin)",
  onlySuperAdminCanChangeCurrency: "Yalnız SuperAdmin valyutanı dəyişə bilər",
  noChangesToSave: "Saxlanılacaq dəyişiklik yoxdur",
  
  // Languages
  english: "İngiliscə",
  turkish: "Türkcə",
  azerbaijani: "Azərbaycanca",
  
  // Users
  users: "İstifadəçilər",
  newUser: "+ Yeni İstifadəçi",
  name: "Ad",
  email: "E-poçt",
  phone: "Telefon",
  role: "Rol",
  admin: "Admin",
  residentRole: "Sakin",
  userCreated: "İstifadəçi yaradıldı",
  userUpdated: "İstifadəçi yeniləndi",
  editUser: "İstifadəçini Redaktə Et",
  resetPassword: "Şifrəni Sıfırla",
  resetPasswordFor: "Şifrə sıfırlama üçün",
  newPassword: "Yeni Şifrə",
  enterNewPassword: "Yeni şifrə daxil edin",
  passwordMinLength: "Şifrə ən azı 6 simvol olmalıdır",
  passwordResetSuccess: "Şifrə uğurla sıfırlandı",
  authType: "Autentifikasiya Tipi",
  usernameExists: "İstifadəçi adı artıq mövcuddur",
  emailOptional: "E-poçt (məcburi deyil)",
  phoneOptional: "Telefon (məcburi deyil)",
  actions: "Əməliyyatlar",
  apartmentNo: "Mənzil №",
  noApartment: "Mənzil yoxdur",
  apartmentRequired: "Mənzil məcburidir",
  apartmentRequiredForResident: "Sakin istifadəçilər üçün mənzil məcburidir",
  selectApartment: "Mənzil seçin",
  apartment: "Mənzil",
  optional: "Məcburi deyil",
  
  // SuperAdmin Building Selection
  selectBuilding: "Bina Seç",
  selectedBuilding: "Seçilmiş Bina",
  viewingAsAdmin: "Admin Olaraq Baxış",
  noBuildingSelected: "Bina seçilməyib",
  viewAdminPanel: "Admin Panelini Göstər",
  backToSuperAdmin: "Super Adminə Qayıt",
  managingBuilding: "İdarə Edilən Bina",
  
  // Errors
  operationFailed: "Əməliyyat uğursuz oldu",
  loadDataFailed: "Məlumat yüklənə bilmədi",
  authenticationFailed: "Kimlik təsdiqi uğursuz oldu",
  
  // Misc
  count: "Sayı",
  totalItems: "Ümumi Elementlər",
  manageUsers: "İstifadəçiləri idarə et",
  
  // Months
  months: {
    1: "Yanvar",
    2: "Fevral",
    3: "Mart",
    4: "Aprel",
    5: "May",
    6: "İyun",
    7: "İyul",
    8: "Avqust",
    9: "Sentyabr",
    10: "Oktyabr",
    11: "Noyabr",
    12: "Dekabr"
  },

  // Resident Portal
  maintenanceStatus: "Ödəniş Statusu",
  lastSixMonths: "Son 6 Ay",
  paymentReport: "Ödəniş Hesabatı",
  unpaidBalance: "Ödənilməmiş Balans",
  totalPaidLabel: "Ümumi Ödənilmiş",
  totalUnpaidMonths: "Ümumi Ödənilməmiş Ay Sayı",
  unpaidMonthsCount: "Ödənilməmiş Ay Sayı",
  lastFeeAmount: "Son Ödəniş Məbləği",
  feeAmount: "Ödəniş Məbləği",
  payMaintenance: "Ödəniş Et",
  viewReportAndPay: "Hesabatı Göstər və Ödə",
  monthTotal: "Aylıq Cəmi",
  monthShort: {
    1: "Yan",
    2: "Fev",
    3: "Mar",
    4: "Apr",
    5: "May",
    6: "İyn",
    7: "İyl",
    8: "Avq",
    9: "Sen",
    10: "Okt",
    11: "Noy",
    12: "Dek"
  },
  recentAnnouncements: "Son Elanlar",
  monthlyExpenses: "Aylıq Xərclər",
  monthlySummary: "Aylıq Maliyyə Xülasəsi",
  carryover: "Köçürmə",
  carryoverFromPrevMonth: "Əvvəlki Aydan",
  income: "Gəlir",
  expenses: "Xərc",
  balance: "Balans",
  viewDetailedReport: "Ətraflı Hesabatı Göstər",
  year: "İli",
  totalIncome: "Ümumi Gəlir",
  totalExpense: "Ümumi Xərc",
  netBalance: "Xalis Balans",
  viewReports: "Hesabatlara Bax",
  investments: "İnvestisiyalar",
  completed: "Tamamlandı",
  inProgress: "Davam Edir",
  planned: "Planlaşdırılıb",
  newInvestment: "+ Yeni İnvestisiya",
  investmentCreated: "İnvestisiya yaradıldı",
  investmentDeleted: "İnvestisiya silindi",
  deleteInvestment: "Bu investisiyanı silmək istədiyinizdən əminsiniz?",
  noInvestmentsYet: "Hələ qeydə alınmış investisiya yoxdur",
  startDate: "Başlama Tarixi",
  completedDate: "Tamamlanma Tarixi",
  endDate: "Bitmə Tarixi",
  investmentCategoryLabel: "İnvestisiya Kateqoriyası",
  investmentCategoryPlaceholder: "İnvestisiya kateqoriyası seçin",
  investmentSubcategoryLabel: "İnvestisiya Alt Kateqoriyası",
  investmentSubcategoryPlaceholder: "İnvestisiya alt kateqoriyası seçin",
  investmentCategoryRequired: "İnvestisiya kateqoriyası seçimi məcburidir",
  investmentSubcategoryRequired: "İnvestisiya alt kateqoriyası seçimi məcburidir",
  descriptionRequired: "Təsvir məcburidir",
  endDateBeforeStartDate: "Bitmə tarixi başlama tarixindən əvvəl ola bilməz",
  startDateRequired: "Başlama tarixi məcburidir",
  
  // İnvestisiya Kateqoriyaları
  investmentCategories: {
    physical: "Fiziki / Struktur İnvestisiyalar",
    energy: "Enerji & Səmərəlilik İnvestisiyaları",
    security: "Təhlükəsizlik & Texnologiya",
    social: "Sosial Sahələr & Rahatlıq",
    legal: "Layihə & Hüquqi İnvestisiyalar"
  },
  
  // İnvestisiya Alt Kateqoriyaları
  investmentSubcategories: {
    physical: {
      elevatorRenovation: "Lift Yeniləmə",
      roofRenovation: "Dam Yeniləmə / İzolasiya",
      exteriorInsulation: "Xarici İzolasiya (Fasad)",
      parkingConstruction: "Dayanacaq Sahəsinin Tikintisi / İyileşdirmə",
      earthquakeReinforcement: "Zəlzələyə Davamlılıq",
      fireSystemInstallation: "Yanğın Sisteminin Quraşdırılması",
      waterTankRenovation: "Su Çəni Yeniləmə",
      generatorInstallation: "Generator Quraşdırılması"
    },
    energy: {
      solarPanels: "Günəş Panelləri (PV / GES)",
      heatPump: "İstilik Pompası",
      ledConversion: "Ümumi Sahə LED Çevrilməsi",
      smartMeterSystems: "Ağıllı Sayğac Sistemləri",
      insulationImprovements: "İzolasiya İyileşdirmələri"
    },
    security: {
      cameraSystem: "Kamera Sistemi (CCTV)",
      accessCardSystem: "Kartlı Giriş Sistemi",
      smartBuildingInfrastructure: "Ağıllı Bina İnfrastrukturu",
      intercomRenovation: "Domofon / Qapı Telefonu Yeniləmə",
      buildingManagementSoftware: "Bina İdarəetmə Proqramı (İlk Quraşdırma)"
    },
    social: {
      childrensPlayground: "Uşaq Oyun Sahəsi",
      sportsAreaFitness: "İdman Sahəsi / Fitness",
      landscapingRenovation: "Abadlaşdırma Yeniləmə (Birdəfəlik)",
      pergolaSeatingAreas: "Pergola / Kölgəlik / Oturma Sahələri",
      commonAreaDecoration: "Ümumi Sahə Dekorasiya Layihələri"
    },
    legal: {
      architecturalDesign: "Memarlıq Dizayn Layihəsi",
      structuralProject: "Struktur (Statik) Layihə",
      municipalityPermit: "Bələdiyyə / İcazə Əsaslı Layihə Xərcləri",
      condominiumTransition: "Mənzil Mülkiyyəti Keçid İşləri"
    }
  },
  manageInvestments: "Bina layihələrini idarə et",
  
  // Other Income
  otherIncome: "Digər Gəlirlər",
  otherIncomeTitle: "Digər Gəlir İdarəsi",
  manageOtherIncome: "Əlavə gəlir mənbələrini idarə et",
  newOtherIncome: "Yeni Gəlir Qeydi",
  addIncome: "+ Gəlir əlavə et",
  category: "Kateqoriya",
  description: "Təsvir",
  amount: "Məbləğ",
  date: "Tarix",
  otherIncomeCreated: "Gəlir qeydi uğurla yaradıldı",
  otherIncomeUpdated: "Gəlir qeydi uğurla yeniləndi",
  otherIncomeDeleted: "Gəlir qeydi uğurla silindi",
  editOtherIncome: "Gəlir Qeydini Redaktə Et",
  deleteOtherIncome: "Gəlir Qeydini Sil",
  confirmDeleteOtherIncome: "Bu gəlir qeydini silmək istədiyinizdən əminsiniz?",
  
  // Other Income Categories
  incomeCategory: "Gəlir Kateqoriyası",
  commonAreaRental: "Ümumi Sahə Kirayəsi",
  parkingFees: "Parkinq Ödənişləri",
  facilityUsageFees: "Obyekt İstifadə Ödənişləri",
  penalties: "Cərimələr / Kompensasiyalar",
  keyCardFees: "Açar / Kart Ödənişləri",
  otherCategory: "Digər",
  
  // Financial Reports
  incomeBreakdown: "Gəlir Bölgüsü",
  expenseBreakdown: "Xərc Bölgüsü",
  maintenanceFeeIncome: "Ödəniş Gəliri",
  latePaymentFees: "Gecikmə Cərimələri",
  otherIncomeTotal: "Digər Gəlirlər",
  regularExpenses: "Adi Xərclər",
  investmentsTotal: "İnvestisiyalar",
  totalIncome: "Ümumi Gəlir",
  netBalance: "Xalis Balans",
  incomeExpenseReport: "Gəlir & Xərc Hesabatı",
  viewDetailedReport: "Ətraflı Hesabatı Göstər",
  
  // Detailed Report Modal - New Keys
  detailedReportTitle: "Aylıq Maliyyə Hesabatı",
  incomeSectionTitle: "Gəlir Təfərrüatları",
  aidatIncomeLabel: "Ödəniş Gəliri",
  aidatIncomeNote: "Bu ay ödənilən ödənişlərdən",
  assignedAidatIncomeLabel: "Təyin Olunmuş Ödəniş Gəliri",
  assignedAidatIncomeNote: "Mənzilə təyin olunmuş ödənişlər",
  pendingPoolIncomeLabel: "Gözləyən Hovuz Gəliri",
  pendingPoolIncomeNote: "Hələ mənzilə təyin olunmamış ödənişlər",
  otherIncomeSectionTitle: "Digər Gəlirlər",
  otherIncomeTotalLabel: "Digər Gəlirlər Cəmi",
  expensesSectionTitle: "Xərc Təfərrüatları",
  expenseItemsSectionTitle: "Xərclər",
  expensesTotalLabel: "Xərclər Cəmi",
  investmentsSectionTitle: "İnvestisiyalar",
  investmentsTotalLabel: "İnvestisiyalar Cəmi",
  noIncomeThisMonth: "Bu ay gəlir qeydi yoxdur",
  noOtherIncomeThisMonth: "Bu ay digər gəlir yoxdur",
  noExpensesThisMonth: "Bu ay xərc qeydi yoxdur",
  noInvestmentsThisMonth: "Bu ay investisiya yoxdur",
  
  // Print
  print: "Çap et",
  
  // SuperAdmin & Buildings
  superAdminPortal: "Super Admin Portalı",
  buildings: "Binalar",
  buildingManagement: "Bina İdarəsi",
  createBuilding: "Yeni Bina Yarat",
  editBuilding: "Binanı Redaktə Et",
  buildingName: "Bina Adı",
  buildingAddress: "Bina Ünvanı",
  numberOfFloors: "Mərtəbə Sayı",
  numberOfApartments: "Ümumi Mənzillər",
  buildingAdmin: "Bina İdarəçisi",
  adminFullName: "İdarəçi Adı Soyadı",
  adminUsername: "İdarəçi İstifadəçi Adı",
  adminPassword: "İdarəçi Şifrəsi",
  adminPhone: "İdarəçi Telefon",
  adminEmail: "İdarəçi E-poçt",
  buildingCreated: "Bina uğurla yaradıldı",
  buildingUpdated: "Bina uğurla yeniləndi",
  buildingDeleted: "Bina uğurla silindi",
  viewBuilding: "Binanı Göstər",
  deleteBuilding: "Binanı Sil",
  confirmDeleteBuilding: "Bu binanı silmək istədiyinizdən əminsiniz?",
  buildingDetails: "Bina Təfərrüatları",
  manageBuildings: "Binaları və idarəçiləri idarə et",
  noBuildings: "Hələ bina yoxdur",
  leaveBlankToKeep: "Cari şifrəni saxlamaq üçün boş buraxın",
  
  // Change Password
  changePassword: "Şifrəni Dəyişdir",
  currentPassword: "Cari Şifrə",
  newPassword: "Yeni Şifrə",
  confirmNewPassword: "Yeni Şifrəni Təsdiqlə",
  passwordChangedSuccess: "Şifrəniz uğurla dəyişdirildi",
  currentPasswordIncorrect: "Cari şifrə yanlışdır",
  passwordsDoNotMatch: "Şifrələr uyğun gəlmir",
  passwordTooWeak: "Şifrə ən azı 6 simvol olmalıdır",
  newPasswordSameAsOld: "Yeni şifrə cari şifrədən fərqli olmalıdır",
  enterCurrentPassword: "Cari şifrənizi daxil edin",
  enterNewPassword: "Yeni şifrənizi daxil edin",
  confirmPassword: "Yeni şifrənizi təsdiqləyin",
  passwordChangeError: "Şifrə dəyişdirilə bilmədi. Yenidən cəhd edin.",
  
  // Payment Status Modal
  paymentStatusTitle: "Ödəniş Statusu",
  previousYearBalance: "Əvvəlki İldən Gələn Balans",
  carryOverDebt: (year) => `${year} ilindən köçürülmüş borc balansı`,
  payUnpaidFees: "Ödənilməmiş Ödənişləri Et",
  paySelectedUnpaidFees: "Seçilmiş Ödənişləri Et",
  devir: "Devir Balansı",
  devirDesc: "Əvvəlki ildən keçən balans",
  partiallyPaid: "Qismən Ödənildi",
  paidAmount: "Ödənilən",
  remainingAmount: "Qalan",
  otherPaymentLabel: "Digər Ödəniş",
  cumulativeBalance: "Kümülatif Qalan",
  collapseYear: "İli daralt",
  expandYear: "İli genişlət",
  paymentDate: "Ödəniş Tarixi",
  selectPaymentDate: "Ödəniş Tarixini Seçin",
  noFeesFound: "Hələ ödəniş qeydi tapılmadı.",
  paymentSummaryTitle: "Ödəniş Xülasəsi",
  paymentSummaryDescription: "Ödənişdən əvvəl seçilmiş ödənişləri nəzərdən keçirin",
  confirmPayment: "Ödənişi Təsdiqlə",
  cancelPayment: "Ləğv et",
  selectedTotal: "Seçilmiş Cəmi",
  monthsToPay: "Ödəniləcək Aylar",
  totalAidat: "Ümumi Aidat",
  totalOtherPayment: "Ümumi Digər Ödəniş",
  totalPaid: "Ümumi Ödənilən",
  totalRemaining: "Ümumi Qalıq",
  makePayment: "Ödəniş Et",
  paymentAmountLabel: "Ödəniş Məbləği",
  paymentAmountExceedsDebt: "Ödəniş məbləği ümumi borcdan artıq ola bilməz",
  paymentAmountMustBePositive: "Ödəniş məbləği müsbət olmalıdır",
  totalDebt: "Ümumi Borc",
  maintenanceFee: "Aidat",
  otherPaymentCol: "Digər Ödəniş",
  paidAmountCol: "Ödənilən",
  remainingCumulative: "Qalıq (Küm.)",
  yearSummary: "İl Xülasəsi",
  
  // Bank Statement Name Matching
  matchStatistics: "Uyğunlaşma Statistikası",
  byUnitNumber: "Mənzil No ilə",
  byFullName: "Tam Ad ilə",
  bySimilarName: "Oxşar Ad ilə",
  needsReview: "Nəzərdən Keçirmə Lazım",
  dataConflicts: "Məlumat Ziddiyyəti",
  matchType: "Uyğunlaşma Növü",
  matchedByUnitNumber: "Mənzil nömrəsinə görə uyğunlaşdırıldı",
  matchedByFullName: "Tam ad uyğunluğu",
  matchedBySimilarName: "Oxşar ad uyğunluğu",
  lowConfidence: "Aşağı Etibar",

  // WhatsApp Templates
  waTemplateDuesReminder: "Ödəniş Xatırlatması",
  waTemplateDuesReminderDesc: "Sakinlərə ödənilməmiş ödənişlər barədə bildiriş göndərir",
  waTemplateDuesReminderBody: "Hörmətli {{residentName}}, {{apartmentNumber}} nömrəli mənzilinizin ödənilməmiş ödənişi {{amount}} məbləğindədir. Zəhmət olmasa ödənişi tamamlayın.",
  waTemplateAnnouncementGeneral: "Ümumi Elan",
  waTemplateAnnouncementGeneralDesc: "Ümumi bina elanı göndərir",
  waTemplateAnnouncementGeneralBody: "Yeni elan: {{announcementText}}",
  waTemplateVarResidentName: "Sakin Adı",
  waTemplateVarApartmentNumber: "Mənzil Nömrəsi",
  waTemplateVarAmount: "Məbləğ",
  waTemplateVarAnnouncementText: "Elan Mətni",
  waPageTitle: "WhatsApp",
  waPageSubtitle: "Sakinlərə bildiriş göndərin",
  waSendTab: "Mesaj Göndər",
  waLogTab: "Mesaj Tarixi",
  waTemplatesTab: "Şablonlar",
  waTemplateMode: "Şablon",
  waTextMode: "Sərbəst Mətn",
  waRecipientPhone: "Alıcı Telefon",
  waMessageBody: "Mesaj",
  waTextPlaceholder: "Mesajınızı yazın...",
  waSelectTemplate: "Şablon",
  waLanguage: "Dil",
  waVariables: "Dəyişənlər",
  waPreview: "Önbaxış",
  waSendBtn: "WhatsApp Mesajı Göndər",
  waSending: "Göndərilir...",
  waPhoneRequired: "Telefon nömrəsi tələb olunur",
  waMessageRequired: "Mesaj tələb olunur",
  waFillAllVars: "Bütün şablon dəyişənlərini doldurun",
  waMessageSent: "Mesaj göndərildi",
  waTemplateSent: "Şablon mesajı göndərildi",
  waError: "Xəta",
  waTextWarning: "Sərbəst mətn mesajları yalnız son 24 saat ərzində işinizə mesaj göndərmiş alıcılara çatdırılır. İlk mesajlar üçün şablon istifadə edin.",
  waResidents: "Telefonlu Sakinlər",
  waNoResidents: "Telefon nömrəsi olan sakin tapılmadı",
  waNoMessages: "Hələ mesaj göndərilməyib",
  waDate: "Tarix",
  waRecipient: "Alıcı",
  waType: "Növ",
  waContent: "Məzmun",
  waStatus: "Status",
  waSentBy: "Göndərən",
  waNavDesc: "Bildiriş göndər"
};
